import React, { memo, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Avatar from '@atlaskit/avatar';
import { Box, xcss } from '@atlaskit/primitives';
import type { User } from '@atlaskit/user-picker';

export type Props = {
	user: User;
};

export const UserCell = memo<Props>(({ user }: Props) => (
	<NameWrapper>
		<AvatarWrapper>
			<Avatar name={user.name} src={user.avatarUrl} size="small" />
		</AvatarWrapper>
		<div data-testid="issue-archival-archives.ui.archives-table.rows.user-cell.user-name">
			{user.name}
		</div>
	</NameWrapper>
));

const NameWrapper = ({ children }: { children: ReactNode }) => (
	<NameWrapperStyles>{children}</NameWrapperStyles>
);

const AvatarWrapper = ({ children }: { children: ReactNode }) => (
	<Box xcss={avatarWrapperStyles}>{children}</Box>
);

const avatarWrapperStyles = xcss({
	marginInlineEnd: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const NameWrapperStyles = styled.span({
	display: 'flex',
	alignItems: 'center',
});
